import HookAddressAutocompleteFormControl from './Autocomplete/Address/HookAddressAutocompleteFormControl';
import HookAutocompleteFormControl from './Autocomplete/HookAutocompleteFormControl';
import HookCheckFormControl from './Check/HookCheckFormControl';
import HookDateFormControl from './Date/HookDateFormControl';
import HookEmailFormControl from './Email/HookEmailFormControl';
import HookMoneyFormControl from './Money/HookMoneyFormControl';
import HookRadioFormControl from './Radio/HookRadioFormControl';
import HookApproximateAgeFormControl from './Select/ApproximateAge/HookApproximateAgeFormControl';
import HookCountryFormControl from './Select/Country/HookCountryFormControl';
import HookSelectFormControl from './Select/HookSelectFormControl';
import HookObserverRelationshipFormControl from './Select/ObserverRelationship/HookObserverRelationshipFormControl';
import HookStateFormControl from './Select/State/HookStateFormControl';
import HookSuffixFormControl from './Select/Suffix/HookSuffixFormControl';
import HookPasswordFormControl from './Text/HookPasswordFormControl';
import HookTextFormControl from './Text/HookTextFormControl';
import HookToggleFormControl from './Toggle/HookToggleFormControl';

import { lazyWithRetry } from 'utils/lazy-with-retry';

const HookPhoneFormControl = lazyWithRetry(() => import('./Phone/HookPhoneFormControl'));

const HookFormControl = {
    AddressAutocomplete: HookAddressAutocompleteFormControl,
    ApproximateAge: HookApproximateAgeFormControl,
    Autocomplete: HookAutocompleteFormControl,
    Check: HookCheckFormControl,
    Country: HookCountryFormControl,
    Date: HookDateFormControl,
    Email: HookEmailFormControl,
    Money: HookMoneyFormControl,
    ObserverRelationship: HookObserverRelationshipFormControl,
    Password: HookPasswordFormControl,
    Phone: HookPhoneFormControl,
    Radio: HookRadioFormControl,
    Select: HookSelectFormControl,
    State: HookStateFormControl,
    Suffix: HookSuffixFormControl,
    Text: HookTextFormControl,
    Toggle: HookToggleFormControl,
};

export default HookFormControl;
